import { isHotkeyPressed } from "react-hotkeys-hook";
import { ConfirmationDialog } from "./ConfirmationDialog";
import { launchDialog } from './DialogHelper';


export async function showConfirmationDialog(title: string, body: string, yesAction?: string, noAction?: string, hideIcon?:boolean, width?: string): Promise<boolean> {
    if (isHotkeyPressed('shift')) return true;
    try {
        var result = await launchDialog<boolean>((deferred) => <ConfirmationDialog
            deferred={deferred}
            title={title}
            body={body}
            yesAction={yesAction}
            noAction={noAction}
            hideIcon={hideIcon}
            width={width}
        />)
        return result;
    } catch (error) {
        return false;
    }
}
